module.exports = __webpack_public_path__ + "static/media/stock5.58cc71a7.jpg";